import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthUserService } from './auth-user.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedGuard {
  constructor(private readonly authUserService: AuthUserService,
              private readonly router: Router) {
  }

  canActivate(): boolean | UrlTree {
    if (this.authUserService.isAuthenticated()) {
      return true;
    }

    return this.router.parseUrl('/login');
  }

  canActivateChild() {
    return this.canActivate();
  }
}

@Injectable({ providedIn: 'root' })
export class UnAuthenticatedGuard {
  constructor(private readonly authUserService: AuthUserService,
              private readonly router: Router) {
  }

  canActivate(): boolean | UrlTree {
    if (!this.authUserService.isAuthenticated()) {
      return true;
    }

    return this.router.parseUrl('/');
  }

  canActivateChild() {
    return this.canActivate();
  }
}
